<div class="recorder_modal create-recorder-heatmap confirmation_modal">
  <p class="recorder_modal_title">Download Options</p>
  <div class="recorder_modal_text">
    Choose whether to include URLs in your raw data export. Including URLs may
    increase file size.
  </div>

  <div style="display: flex; gap: 16px; margin-bottom: 16px">
    <button
      mat-raised-button
      (click)="dialogRef.close(1)"
      style="background: var(--border-color-theme) !important; flex: 1"
    >
      {{ "phrases.raw_data" | translate }}
    </button>
    <button
      mat-raised-button
      (click)="dialogRef.close(2)"
      style="background: var(--border-color-theme) !important; flex: 1"
    >
      {{ "phrases.raw_data" | translate }} + URLs
    </button>
  </div>

  <div class="button_container">
    <button mat-raised-button (click)="dialogRef.close(0)" class="seo_cancel">
      {{ "words.cancel" | translate }}
    </button>
  </div>
</div>
